import { render, staticRenderFns } from "./Roof.vue?vue&type=template&id=0a3f89b7&lang=pug&"
import script from "./Roof.vue?vue&type=script&lang=js&"
export * from "./Roof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports